import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Plus, Zap, Play, Settings } from "lucide-react";
import { WorkflowBuilder } from "@/components/automation/WorkflowBuilder";
import { AutomationTemplates } from "@/components/automation/AutomationTemplates";
import { AutomationAnalytics } from "@/components/automation/AutomationAnalytics";
import { WorkflowList } from "@/components/automation/WorkflowList";
import { ActivateAllTemplates } from "@/components/automation/ActivateAllTemplates";

export default function AutomationStudio() {
  const [activeTab, setActiveTab] = useState("workflows");
  const [selectedWorkflow, setSelectedWorkflow] = useState<string | null>(null);
  const [isBuilderOpen, setIsBuilderOpen] = useState(false);

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Automation Studio</h1>
          <p className="text-muted-foreground">Create powerful automations to streamline your workflow</p>
        </div>
        <div className="flex gap-2">
          <ActivateAllTemplates />
          <Button onClick={() => setIsBuilderOpen(true)} size="lg">
            <Plus className="mr-2 h-5 w-5" />
            Create Automation
          </Button>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="workflows">
            <Zap className="mr-2 h-4 w-4" />
            My Workflows
          </TabsTrigger>
          <TabsTrigger value="templates">
            <Settings className="mr-2 h-4 w-4" />
            Templates
          </TabsTrigger>
          <TabsTrigger value="analytics">
            <Play className="mr-2 h-4 w-4" />
            Analytics
          </TabsTrigger>
          <TabsTrigger value="builder">
            <Plus className="mr-2 h-4 w-4" />
            Builder
          </TabsTrigger>
        </TabsList>

        <TabsContent value="workflows">
          <WorkflowList onEdit={(id) => {
            setSelectedWorkflow(id);
            setActiveTab("builder");
          }} />
        </TabsContent>

        <TabsContent value="templates">
          <AutomationTemplates onUseTemplate={(template) => {
            console.log('Using template:', template);
            setActiveTab("builder");
          }} />
        </TabsContent>

        <TabsContent value="analytics">
          <AutomationAnalytics />
        </TabsContent>

        <TabsContent value="builder">
          <WorkflowBuilder workflowId={selectedWorkflow} />
        </TabsContent>
      </Tabs>
    </div>
  );
}